<template>
  <v-container>
    <h2>Mobile Driver Settings</h2>
    <v-row v-for="(prop, index) in properties" :key="index">
      <v-col v-if="prop.key === 'mobileDriverShowOperatorButton'">
        <h4>{{ translations.mobileDriverShowOperatorButton }}</h4>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque cumque dolores, ea est expedita fugiat iusto molestiae molestias neque officia officiis optio possimus, quas quo repellendus sapiente ullam, veniam voluptatibus.</p>
        <v-btn-toggle>
          <v-btn :disabled="prop.value === 'true'" @click="updateValue('enable', index)">Enable</v-btn>
          <v-btn :disabled="prop.value === 'false'" @click="updateValue('disable', index)">Disable</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col v-if="prop.key === 'mobileDriverShowMillingButton'">
        <h4>{{ translations.mobileDriverShowMillingButton }}</h4>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque cumque dolores, ea est expedita fugiat iusto molestiae molestias neque officia officiis optio possimus, quas quo repellendus sapiente ullam, veniam voluptatibus.</p>
        <v-btn-toggle>
          <v-btn :disabled="prop.value === 'true'" @click="updateValue('enable', index)">Enable</v-btn>
          <v-btn :disabled="prop.value === 'false'" @click="updateValue('disable', index)">Disable</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col v-if="prop.key === 'mobileDriverShowDDTButton'">
        <h4>{{ translations.mobileDriverShowDDTButton }}</h4>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque cumque dolores, ea est expedita fugiat iusto molestiae molestias neque officia officiis optio possimus, quas quo repellendus sapiente ullam, veniam voluptatibus.</p>
        <v-btn-toggle>
          <v-btn :disabled="prop.value === 'true'" @click="updateValue('enable', index)">Enable</v-btn>
          <v-btn :disabled="prop.value === 'false'" @click="updateValue('disable', index)">Disable</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col v-if="prop.key === 'mobileDriverShowPreparationButton'">
        <h4>{{ translations.mobileDriverShowPreparationButton }}</h4>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque cumque dolores, ea est expedita fugiat iusto molestiae molestias neque officia officiis optio possimus, quas quo repellendus sapiente ullam, veniam voluptatibus.</p>
        <v-btn-toggle>
          <v-btn :disabled="prop.value === 'true'" @click="updateValue('enable', index)">Enable</v-btn>
          <v-btn :disabled="prop.value === 'false'" @click="updateValue('disable', index)">Disable</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-btn @click.prevent="saveSettings" color="main" class="white--text px-8 mt-8">Save</v-btn>
  </v-container>
</template>


<script>
import PropertyService from '@/service/property/PropertyService'
import { translations } from '@/utils/common'

export default {
  props: ['mobileDriverProperties'],

  data() {
    return {
      properties: [],
      selectedValue: ''
    }
  },

  computed: {
    translations() {
      return translations
    }
  },

  mounted() {
    this.properties = this.mobileDriverProperties
  },

  methods: {
    updateValue(status, index) {
      this.selectedValue = status === 'enable'
      this.properties[index].value = this.selectedValue === true
    },

    async saveSettings() {
      this.properties.forEach(prop => {
        if (prop.value === '') {
          prop.value = null
        }
      })
      const propertiesDTO = this.properties.map(({ key, value, type }) => ({
        key,
        value,
        type
      }))
      await PropertyService.saveList({ propertiesDTO: propertiesDTO })
        .then(() => {
          this.$root.vtoast.show({ message: translations.updateSuccess })
          this.$emit('updated')
        })
        .catch(() => {
          this.showErrorMsgDialog = true
        })
    }
  }
}
</script>


<style scoped>
h2 {
  margin-bottom: 15px;
}
</style>
